import * as THREE from 'three';
import { Facade } from './Facade';
import { addLights } from './SceneHelpers';
import { SceneCamera } from './SceneCamera';

const camNear = 0.001;
const camFar = 1000;
const camFov = 60.0;

export function renderAsPixels(
  width,
  height,
  windowsDefinition,
  dimensions,
  showInnerSide,
  showMeasurements,
  flipVerticalMeasurements
) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const gl = canvas.getContext('webgl');
  const renderer = new THREE.WebGLRenderer({
    context: gl,
    canvas: canvas,
    precision: 'highp',
    antialias: true,
    alpha: true,
    preserveDrawingBuffer: true,
  });
  renderer.setSize(width, height);
  renderer.setClearColor(0xffffff, 1);
  const scene = new THREE.Scene();

  const imageEngineData = {
    renderer: renderer,
    scene: scene,
    flipVerticalMeasurements: flipVerticalMeasurements,
  };
  const facade = new Facade(imageEngineData, scene);
  facade.loadJson(windowsDefinition);
  if (showMeasurements) {
    facade.toggleAllMeasurements();
  }

  addLights(scene);

  let camera;
  if (dimensions === 2) {
    camera = imageEngineData.camera = new SceneCamera(
      new THREE.OrthographicCamera(
        -facade.width / 2 - 1 / 2000, // Adding half of a millimeter allows us to see the outer border of the window
        facade.width / 2 + 1 / 2000,
        facade.height / 2 + 1 / 2000,
        -facade.height / 2 - 1 / 2000,
        camNear,
        camFar
      )
    );
  } else if (dimensions === 3) {
    camera = imageEngineData.camera = new SceneCamera(
      new THREE.PerspectiveCamera(camFov, width / height, camNear, camFar)
    );
  } else {
    throw 'Invalid dimension.';
  }

  camera.lookAtObject(facade.obj);
  if (showInnerSide) {
    camera.setCameraRotation(Math.PI);
  } else {
    camera.setCameraRotation(0);
  }
  camera.zoomToFit(renderer, facade.obj, 1);

  // Updates mosquito net(s), measurement labels etc on the windows in the facade.
  facade.onRendererResize();
  
  if (showMeasurements) {
    // Due to measurement labels changing size from the call above, the camera may no longer
    // be centered and zoomed properly, thus we need to center and zoom it again.
    camera.lookAtObject(facade.obj);
    camera.zoomToFit(renderer, facade.obj, 1);
  }

  const rtTexture = new THREE.WebGLMultisampleRenderTarget(width, height, {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.NearestFilter,
    format: THREE.RGBAFormat,
  });
  renderer.setRenderTarget(rtTexture);
  renderer.clear();
  renderer.render(scene, camera.obj);
  const pixels = new Uint8Array(4 * width * height);
  gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
  facade.clear();
  rtTexture.dispose();
  renderer.dispose();
  return pixels;
}
